import api from "../api/api";
import { QueryAction } from "../enums/action.enum";
import { ApiTypeEnum } from "../enums/api-type.enum";
import { SEND_EMAIL_QUERY } from "../graphql/queries/admin.query";

export const sendEmailService = (data) => {
    return api.call({
      type: ApiTypeEnum.Other,
      data: { ...data },
      query:  SEND_EMAIL_QUERY,
      action: QueryAction.GET,
    });
  };